var React = require('react');

function StarAlt (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10.0001 3L11.3044 7.58682L15.6137 5.77301L12.9308 9.67858L17 12.0034L12.3504 12.2873L13.1155 17L10.0001 13.4482L6.88477 17L7.64988 12.2873L3 12.0034L7.06947 9.67858L4.38651 5.77301L8.69584 7.58682L10.0001 3Z","stroke":"#001D3B","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

StarAlt.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = StarAlt;

StarAlt.default = StarAlt;
